import React, {Component} from 'react';
import {
    View,
    TextInput,
    BackHandler,
    Alert,
    Image,
    TouchableOpacity,
    Platform,
    KeyboardAvoidingView,
    ScrollView
} from "react-native"

import {verticalScale, moderateScale, scale} from "../../../../tools/Scaling";

import DialogConnectionCustomize from "../../../../customviews/DialogConnectionCustomize";
import Colors from "../../../../tools/Colors";
import HMTextView from "../../../../customviews/HMTextView";
import DialogLoadingCustomize from "../../../../customviews/DialogLoadingCustomize";
import HMActionBar from "../../../../customviews/HMActionBar";
import i18n from "../../../../I18n/i18n";
import {AsyngStorageClass} from "../../../../tools/AsyngStorageClass";
import {Tools} from "../../../../tools/Tools";
import store from "../../../../redux/store";
import {typeExport} from "../../../../redux/store/type";
import HMAlert from "../../../../customviews/HMAlert";
import FloatingLabelInput from "../../../../customviews/input/floatLabelInput";
import HMIcon from "../../../../customviews/HMIcon";


export default class ChangePassScreen extends Component {

    constructor(props) {
        super(props)
        this.state = {
            // ConfirmPassword: this.props.route.params.ConfirmPassword
            ConfirmPassword: "",
            password: '',
            passwordOld: ''
        }
    }

    async setToken(token) {
        await AsyngStorageClass.setToken(token);

    }

    componentWillReceiveProps(propss) {

        if (propss.results != null) {
            //  this.loadingButton.showLoading(false);

            /*  if (propss.results.success) {
                  alert(propss.results.result)
                  HMAlert(i18n.t('constant.message'), propss.results.result, [
                          // {text: 'Ask me later', onPress: () => {}},
                          // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                          {text: i18n.t('constant.ok'), onPress: () => {
                                  store.dispatch(serviceActionSetState({type: "MainScreen", item: null}))
                                  NavigationService.navigateParams('LoginEnterPhoneScreen')
                              }},
                      ],
                      {cancelable: true}
                  )
                  //   Actions.replace("code");
                  // Actions.code({ ConfirmPassword: this.state.ConfirmPassword, result_extra: propss.results, type_login: this.props.type_login ,AdvertisingChildlist:this.props.AdvertisingChildlist});
                  // this.props.navigation.navigate("EnterCodeScreen", {
                  //     ConfirmPassword: this.state.ConfirmPassword,
                  //     result_extra: propss.results,
                  //     //  type_login: this.props.route.params.type_login
                  //     /!*, AdvertisingChildlist: this.props.route.params.AdvertisingChildlist*!/
                  // });
                  //this.setToken(this.props.route.params.token)
                  //   NavigationService.resetTo('SplashScreen');
                  // this.props.navigation.navigate("EnterCodeScreen", {
                  //     ConfirmPassword: this.state.ConfirmPassword,
                  //     result_extra: propss.results,
                  //     //  type_login: this.props.route.params.type_login
                  //     /!*, AdvertisingChildlist: this.props.route.params.AdvertisingChildlist*!/
                  // });
              } else {
                  alert(propss.results.error ? propss.results.error.message : 'سرور با مشکل مواجه شد')

              }*/
        }

    }

    getData() {
        let {ConfirmPassword, password, passwordOld} = this.state
        let {forgot_my_password} = this.props.route.params

        let paramss = {

            "_operation": typeExport._Contacts,
            "mode": forgot_my_password ? "ForgotPassword" : "ChangePassword",
            "token": store.getState().reducerSplashGetAllData.token,
            "password": passwordOld.trim(),
            "lang": i18n.locale,

            //     "password": "Basic YWRtaW46YWxhdmk/",
            "newPassword": ConfirmPassword.trim(),
        }
        //this.props.callService(typeExport.urlChangPssScreen, `?token=${this.props.route.params.token}&password=${password}&token_fb=${this.props.DataSplashScreen.token_fb}`, typeExport.TypeGetChangPssScreen, "POST");
        this.props.callService(typeExport.urlChangPssScreen, paramss, typeExport.TypeGetChangPssScreen, "POST");

    }

    checkInput() {
        let {forgot_my_password} = this.props.route.params

        if ((Tools.CheckValue(this.state.passwordOld) === null || this.state.passwordOld.trim().length < 6) && !forgot_my_password) {
            HMAlert(
                i18n.t('constant.message'),
                i18n.t('constant.checkPasswordOld'),
                [
                    // {text: 'Ask me later', onPress: () => {}},
                    // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                    {
                        text: i18n.t('constant.ok'), onPress: () => {
                        }
                    },
                ],
                {cancelable: true}
            )
            //alert("شماره را به صورت ۱۱ رقمی و معتبر وارد نمایید")

        } else {
            if (Tools.CheckValue(this.state.password) === null || this.state.password.trim().length < 6) {
                HMAlert(
                    i18n.t('constant.message'),
                    i18n.t('constant.checkPassword'),
                    [
                        // {text: 'Ask me later', onPress: () => {}},
                        // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                        {
                            text: i18n.t('constant.ok'), onPress: () => {
                            }
                        },
                    ],
                    {cancelable: true}
                )
                //alert("شماره را به صورت ۱۱ رقمی و معتبر وارد نمایید")

            } else {
                if (Tools.CheckValue(this.state.ConfirmPassword) === null || this.state.ConfirmPassword.trim().length < 6) {
                    HMAlert(
                        i18n.t('constant.message'),
                        i18n.t('constant.checkConfirmPassword'),
                        [
                            // {text: 'Ask me later', onPress: () => {}},
                            // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                            {
                                text: i18n.t('constant.ok'), onPress: () => {
                                }
                            },
                        ],
                        {cancelable: true}
                    )
                    //alert("شماره را به صورت ۱۱ رقمی و معتبر وارد نمایید")

                } else {
                    if (this.state.ConfirmPassword === this.state.password) {
                        if (this.state.password.trim() !== this.state.passwordOld.trim()) {
                            this.setState({
                                    // mobile: text,
                                }
                                ,
                                () => {
                                    this.getData()
                                }
                            );

                        } else {
                            //  this.loadingButton.showLoading(true);


                            HMAlert(
                                i18n.t('constant.message'),
                                i18n.t('constant.checkPasswordOld_NewPassword'),
                                [
                                    // {text: 'Ask me later', onPress: () => {}},
                                    // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                                    {
                                        text: i18n.t('constant.ok'), onPress: () => {
                                        }
                                    },
                                ],
                                {cancelable: true}
                            )
                            //alert("شماره را به صورت ۱۱ رقمی و معتبر وارد نمایید")


                        }

                    } else {
                        //  this.loadingButton.showLoading(true);


                        HMAlert(
                            i18n.t('constant.message'),
                            i18n.t('constant.errorConfirmPassword'),
                            [
                                // {text: 'Ask me later', onPress: () => {}},
                                // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                                {
                                    text: i18n.t('constant.ok'), onPress: () => {
                                    }
                                },
                            ],
                            {cancelable: true}
                        )
                        //alert("شماره را به صورت ۱۱ رقمی و معتبر وارد نمایید")


                    }

                }

            }

        }
    }

    componentDidMount() {
        // BackHandler.addEventListener('hardwareBackPress', this.handleBackPress);
    }

    componentWillUnmount() {
        //BackHandler.removeEventListener('hardwareBackPress', this.handleBackPress);
    }

    handleBackPress = () => {
        this.goBack(); // works best when the goBack is async
        return true;
    }

    // goBack() {
    //
    //     this.props.navigation.pop();
    //
    //     // switch (this.props.route.params.type_login) {
    //     //
    //     //     case "fav":
    //     //         this.props.navigation.navigate("MainScreen");
    //     //         break;
    //     //
    //     // }
    //
    // }

    render() {
        //  let {changePass} = this.props.route.params
        let {forgot_my_password} = this.props.route.params
        return (
            <View style={{position: 'relative', flex: 1}}>

                <View style={{position: 'absolute', top: 0, bottom: 0, left: 0, right: 0}}>
                    <KeyboardAvoidingView style={{width: "100%", height: "100%"}} behavior={"padding"}
                                          enabled={Platform.OS === "ios"}>
                        <View style={{flex: 1,}}>
                            <HMActionBar
                                props={this.props} statusBarTransparent
                                text={i18n.t('changePass.title')}

                                //  text={i18n.t('constant.Information')}

                                //menu={false}
                                back
                                headerVisibility more_menu
                                onBackPress={() => this.props.navigation.pop()}

                            />
                            <ScrollView
                                keyboardShouldPersistTaps="handled"
                                ref={scroll => this._onRef('_scroll', scroll)}
                                style={{
                                    //backgroundColor: "white"
                                }}>
                                <View style={{width: "100%", marginTop: moderateScale(10)}}>


                                    {
                                        // forgot_my_password ?
                                        //     null
                                        //     :
                                        //
                                        //
                                        //     <HMTextInputEfects
                                        //         value={this.state.passwordOld}
                                        //         type={"Fumi"}
                                        //         label={i18n.t('constant.passwordOld')}
                                        //         onChangeText={text => {
                                        //             this.setState({passwordOld: text})
                                        //         }}
                                        //         iconClass={"FontAwesome"}
                                        //         iconName={'unlock-alt'}
                                        //         secureTextEntry={true}
                                        //         styleRoot={{
                                        //             width: "100%", alignItems: 'center',
                                        //             justifyContent: 'center',
                                        //         }}
                                        //     />
                                    }

                                    {
                                        forgot_my_password ?
                                            null
                                            :
                                            <FloatingLabelInput
                                                label={i18n.t('constant.passwordOld')}

                                                value={this.state.passwordOld}
                                                staticLabel
                                                hintTextColor={'#aaa'}
                                                //mask="99 (99) 99999-9999"
                                                styleRoot={{
                                                    marginVertical: moderateScale(8),
                                                    width: "93%",
                                                    alignSelf: 'center',
                                                }}

                                                hint="رمز عبور فعلی خود را وارد نمایید"
                                                containerStyles={{
                                                    borderWidth: moderateScale(2),
                                                    paddingHorizontal: moderateScale(10),
                                                    backgroundColor: '#fff',
                                                    borderColor: 'blue',
                                                    borderRadius: moderateScale(8),

                                                }}
                                                customLabelStyles={{
                                                    colorFocused: 'red',
                                                    fontSizeFocused: moderateScale(12),
                                                }}
                                                labelStyles={{
                                                    backgroundColor: '#fff',
                                                    paddingHorizontal: moderateScale(5),
                                                }}
                                                inputStyles={{
                                                    color: 'blue',
                                                    paddingHorizontal: moderateScale(2),
                                                    marginVertical: moderateScale(2),
                                                    height: moderateScale(48),
                                                    outlineColor: Colors.transparent
                                                }}
                                                onChangeText={text => {
                                                    this.setState({passwordOld: text})
                                                }}
                                                isPassword
                                                togglePassword={false}
                                                customShowPasswordComponent={<HMIcon name={"eye"} style={{
                                                    color: Colors.blackLight,
                                                    fontSize: moderateScale(18)
                                                }}/>}
                                                customHidePasswordComponent={<HMIcon name={"eye-off"} style={{
                                                    color: Colors.blackLight,
                                                    fontSize: moderateScale(18)
                                                }}/>}

                                                onSubmitEditing={() => this._focusNextField("inputPassword")}
                                                returnKeyType={'next'}
                                            />
                                    }


                                    {/*   <HMTextInputEfects
                                    value={this.state.password}
                                    type={"Fumi"}
                                    label={i18n.t('constant.password')}
                                    onChangeText={text => {
                                        this.setState({password: text})
                                    }}
                                    iconClass={"FontAwesome"}
                                    iconName={'lock'}
                                    secureTextEntry={true}
                                    styleRoot={{
                                        width: "100%", alignItems: 'center',
                                        justifyContent: 'center',
                                    }}
                                />*/}
                                    <FloatingLabelInput
                                        ref={ref => {
                                            this["inputPassword"] = ref
                                        }}
                                        label={i18n.t('constant.password')}

                                        value={this.state.password}
                                        staticLabel
                                        hintTextColor={'#aaa'}
                                        //mask="99 (99) 99999-9999"
                                        styleRoot={{
                                            marginVertical: moderateScale(8),
                                            width: "93%",
                                            alignSelf: 'center',
                                        }}

                                        hint="رمز عبور جدید خود را وارد نمایید"
                                        containerStyles={{
                                            borderWidth: moderateScale(2),
                                            paddingHorizontal: moderateScale(10),
                                            backgroundColor: '#fff',
                                            borderColor: 'blue',
                                            borderRadius: moderateScale(8),

                                        }}
                                        customLabelStyles={{
                                            colorFocused: 'red',
                                            fontSizeFocused: moderateScale(12),
                                        }}
                                        labelStyles={{
                                            backgroundColor: '#fff',
                                            paddingHorizontal: moderateScale(5),
                                        }}
                                        inputStyles={{
                                            color: 'blue',
                                            paddingHorizontal: moderateScale(2),
                                            marginVertical: moderateScale(2),
                                            height: moderateScale(48),
                                            outlineColor: Colors.transparent
                                        }}
                                        onChangeText={text => {
                                            this.setState({password: text})
                                        }}
                                        isPassword
                                        togglePassword={false}
                                        customShowPasswordComponent={<HMIcon name={"eye"} style={{
                                            color: Colors.blackLight,
                                            fontSize: moderateScale(18)
                                        }}/>}
                                        customHidePasswordComponent={<HMIcon name={"eye-off"} style={{
                                            color: Colors.blackLight,
                                            fontSize: moderateScale(18)
                                        }}/>}

                                        onSubmitEditing={() => this._focusNextField("inputConfirmPassword")}
                                        returnKeyType={'next'}
                                    />
                                    {/*    <HMTextInputEfects
                                    value={this.state.ConfirmPassword}

                                    type={"Fumi"}
                                    label={i18n.t('constant.ConfirmPassword')}
                                    onChangeText={text => this.setState({ConfirmPassword: text})}
                                    iconClass={"FontAwesome"}
                                    iconName={'lock'}
                                    secureTextEntry={true}
                                    styleRoot={{
                                        width: "100%", alignItems: 'center',
                                        justifyContent: 'center',
                                    }}
                                />*/}
                                    <FloatingLabelInput
                                        ref={ref => {
                                            this["inputConfirmPassword"] = ref
                                        }}
                                        label={i18n.t('constant.ConfirmPassword')}

                                        value={this.state.ConfirmPassword}
                                        staticLabel
                                        hintTextColor={'#aaa'}
                                        //mask="99 (99) 99999-9999"
                                        styleRoot={{
                                            marginVertical: moderateScale(8),
                                            width: "93%",
                                            alignSelf: 'center',
                                        }}

                                        hint="تکرار رمز عبور جدید خود را وارد نمایید"
                                        containerStyles={{
                                            borderWidth: moderateScale(2),
                                            paddingHorizontal: moderateScale(10),
                                            backgroundColor: '#fff',
                                            borderColor: 'blue',
                                            borderRadius: moderateScale(8),

                                        }}
                                        customLabelStyles={{
                                            colorFocused: 'red',
                                            fontSizeFocused: moderateScale(12),
                                        }}
                                        labelStyles={{
                                            backgroundColor: '#fff',
                                            paddingHorizontal: moderateScale(5),
                                        }}
                                        inputStyles={{
                                            color: 'blue',
                                            paddingHorizontal: moderateScale(2),
                                            marginVertical: moderateScale(2),
                                            height: moderateScale(48),
                                            outlineColor: Colors.transparent
                                        }}
                                        onChangeText={text => {
                                            this.setState({ConfirmPassword: text})
                                        }}
                                        isPassword
                                        togglePassword={false}
                                        customShowPasswordComponent={<HMIcon name={"eye"} style={{
                                            color: Colors.blackLight,
                                            fontSize: moderateScale(18)
                                        }}/>}
                                        customHidePasswordComponent={<HMIcon name={"eye-off"} style={{
                                            color: Colors.blackLight,
                                            fontSize: moderateScale(18)
                                        }}/>}
                                        onSubmitEditing={() => this.checkInput(this.state.ConfirmPassword)}

                                    />
                                    {/* <HMTextInput value={this.state.password}

                                    //keyboardType="numeric"
                                             onChangeText={text => {
                                                 this.setState({password: text})
                                             }}
                                             icon={"md-key"}
                                             autoFocus
                                             _width={'85%'}
                                             placeholder={i18n.t('constant.password')}
                                             NoShowPlaceholder
                                             style={{
                                                 alignSelf: 'center',
                                                 // marginStart: moderateScale(10),
                                                 fontSize: moderateScale(14),
                                                 //  marginTop: moderateScale(6)
                                             }} underlineColorAndroid="transparent" maxLength={11}/>
                                <HMTextInput value={this.state.ConfirmPassword}

                                    //keyboardType="numeric"
                                             onChangeText={text => this._changeText(text)} autoFocus
                                             placeholder={i18n.t('constant.ConfirmPassword')}
                                             NoShowPlaceholder
                                             _width={'85%'}
                                             icon={"md-key"}
                                             style={{

                                                 alignSelf: 'center',
                                                 fontSize: moderateScale(14),
                                                 // marginTop: moderateScale(6)
                                             }} underlineColorAndroid="transparent" maxLength={11}/>*/}


                                    <TouchableOpacity style={{
                                        backgroundColor: Colors.colorPrimary,
                                        width: "93%",
                                        height: moderateScale(40),
                                        alignSelf: 'center',
                                        alignItems: "center",
                                        justifyContent: "center",
                                        marginTop: moderateScale(14),
                                        borderRadius: moderateScale(6)
                                        // borderRadius:moderateScale(2)
                                    }}
                                                      onPress={() => this.checkInput(this.state.ConfirmPassword)}
                                    >
                                        <View
                                            style={{
                                                flexDirection: "row",
                                                alignItems: "center",
                                                justifyContent: "center"
                                            }}>
                                            <HMTextView type={"bold"}
                                                        text={forgot_my_password ? i18n.t('constant.Edit') : i18n.t('constant.signIn')}
                                                        style={{
                                                            color: "white",
                                                            fontSize: moderateScale(16),
                                                            marginEnd: moderateScale(10)
                                                        }}/>

                                        </View>
                                    </TouchableOpacity>
                                </View>
                            </ScrollView>

                        </View>


                        {
                            this.props.NoInternetDialog ?
                                <DialogConnectionCustomize
                                    onPress={() => this.checkInput(this.state.ConfirmPassword)}
                                />
                                :
                                null
                        }
                        {
                            this.props.isLoading ?
                                <DialogLoadingCustomize/>
                                : null
                        }
                    </KeyboardAvoidingView>
                </View>

            </View>

        );
    }

    _onRef = (property, view) => {
        this[property] = view
    }

    _focusNextField(nextField) {
        console.log(nextField, this[nextField]);
        this[nextField].focus()
        // this[nextField].measureLayout(
        //     ReactNative.findNodeHandle(this._scroll),
        //     (x, y) => {
        //         this._scroll.scrollTo({x: 0, y: y - moderateScale(40), animated: true});
        //     }
        // );
    }


}
